import BodyCell, { IBodyCellProps } from './BodyCell';
import BodyCellPure from './BodyCellPure';

export default BodyCell;
export { BodyCellPure };
export type { IBodyCellProps };
